export const CLAIM_CONFIG = {
    TERMS: 'https://support.immutable.com/hc/en-us/sections/4404508717583-Terms-and-Conditions',
    PLAY_TO_EARN: 'https://support.immutable.com/hc/en-us/sections/4404508717583-Terms-and-Conditions',
    TOTAL_POINTS: 94032651,
    ALPHA_CAMPAIGN_TOTAL_IMX: 400000000,
    ENDPOINT: (host: string) => `${host}/rewards`,
    CHECK_STATUS: (status: string) => status === 'unclaimed',
};
